import API from "../../../app/api";

export const getSummary = async (checkoutId) => {
  try {
    const response = await API.get(
      `/checkout/${checkoutId}/summary`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Summary API Error:",
      error
    );
    throw error;
  }
};